export default "/images/loading.svg?330b7d99bfbae8039a5456998d97914f";